import {createActionGroup, emptyProps, props} from '@ngrx/store';
import {ItineraryModel} from "../models/itinerary.model";

export const ItinerariesChannelActions = createActionGroup({
  source: '[Itinerary/Channel]',
  events: {
    subscribe: props<{ ids?: string[] }>(),
    unsubscribe: emptyProps(),
    unsubscribeSuccess: emptyProps(),
    notificationReceived: props<{ notification: ItineraryModel }>(),
  },
});

export const ItinerariesAPiActions = createActionGroup({
  source: '[Itinerary/API]',
  events: {

    //Get Itineraries
    getItineraries: props<{ ids?: string[], isSubscribeToChannel?: boolean }>(),
    getItinerariesSuccess: props<{ itineraries: ItineraryModel[], isSubscribeToChannel?: boolean }>(),
    getItinerariesFailure: props<{ error: any }>(),

  }
});

export const ItinerariesActions = createActionGroup({
  source: '[Itinerary]',
  events: {
    setOne: props<{ itinerary: ItineraryModel }>(),
    setMany: props<{ itineraries: ItineraryModel[] }>(),
    removeByIds: props<{ ids: string[] }>(),
    removeAll: emptyProps(),
  }
});
